module.exports = __webpack_public_path__ + "img/mtnapps.24cf95d0.svg";